import request from '@/utils/request'

export default {
    phoneRechargeJdPay: function (phone, goodsName, amount) {
        return request({
            url: 'jdPay/phoneRecharge',
            method: 'post',
            params: {
                phone: phone,
                goodsName: goodsName,
                amount: amount,
            }
        });
    },
    jingli: function (traderId, phone, pid) {
        return request({
            url: 'jdPay/jingli',
            method: 'post',
            params: {
                traderId: traderId,
                phone: phone,
                pid: pid,
            }
        });
    },
    qishi: function (traderId, phone, pid) {
        return request({
            url: 'jdPay/qishi',
            method: 'post',
            params: {
                traderId: traderId,
                phone: phone,
                pid: pid,
            }
        });
    },
}